import { enableProdMode, APP_INITIALIZER  } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi  } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { ApplicationDataService } from './app/services/application-data.service';
import { routes } from './app/app-routing.module';
import { HttpInterceptorInterceptor } from './app/services/http-interceptor.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { HttpClientUnAuthorizedService } from './app/unauthorized-access.interceptor';

if (environment.production) {
  enableProdMode();
}

export function initApp(appDataService: ApplicationDataService) {
  return () => appDataService.initEnvironments().toPromise();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Lara
      }
    }),
    provideHttpClient(withInterceptorsFromDi()),
    HttpClientUnAuthorizedService,
    provideRouter(routes),
    ApplicationDataService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [ApplicationDataService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorInterceptor,
      multi: true
    }
  ]
}).catch(err => console.error(err));
